export enum BusinessVisaTypeEnum {
    BusinessVisa = "businessVisa",
    EuropeanPassport = "europeanPassport",
    OtherPassport = "otherPassport",
    OtherEuBusinessVisa = "otherEuBusinessVisa",
    OtherEuCountryWorkVisa = "otherEuCountryWorkVisa"
}